import React from "react";

// Small amber flag for a purchase made with a card that is not assigned to the
// vehicle. `expected` is the vehicle's own default card, shown so the reader
// can see which card should have been used. Neutral wording on purpose - it is
// a prompt to look, not a finding.
const MismatchedCardBadge = ({ expected }) => (
  <span
    className="badge"
    style={{ background: "#FFF4E0", color: "#9A5B00", border: "1px solid #F0B95B", fontWeight: 600 }}
    title={expected ? `This vehicle's default card is ${expected}` : "This vehicle has no default card"}
  >
    Mismatched card{expected ? ` · expected ${expected}` : ""}
  </span>
);

export default MismatchedCardBadge;
